import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal, EASE } from "./Reveal";

export const Faq = () => {
  const { t } = useLang();
  const f = t.faq;
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative py-24 lg:py-32 bg-ink-2/40 border-t border-line">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <Reveal>
            <p className="mono-label">{f.eyebrow}</p>
            <h2 className="mt-4 font-display uppercase font-bold tracking-tight leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
              {f.heading}
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-8 border-t border-line">
          {f.items.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-line">
                <button
                  data-testid={`faq-trigger-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                >
                  <h3 className={`font-display uppercase font-bold text-xl sm:text-2xl transition-colors ${isOpen ? "text-hadron-cyan" : "text-txt group-hover:text-hadron-cyan"}`}>
                    {item.q}
                  </h3>
                  <motion.span
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.35, ease: EASE }}
                    className={`shrink-0 h-9 w-9 grid place-items-center border ${isOpen ? "border-hadron-cyan bg-hadron-cyan text-ink" : "border-line text-txt-2 group-hover:border-hadron-cyan group-hover:text-hadron-cyan"}`}
                  >
                    <Plus size={15} />
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      data-testid={`faq-panel-${i}`}
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.45, ease: EASE }}
                      className="overflow-hidden"
                    >
                      <p className="pb-7 pr-10 text-sm lg:text-base text-txt-2 leading-relaxed max-w-3xl">{item.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
